import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ModuleName,
  Modules,
  NotificationHeader,
  NotificationTextMessage,
  RoutingPath,
  Stepper,
  VATReturnStatus,
} from '@app/core/Enum';
import { FinancialData, SubmitVATModel } from '@app/core/Models';
import { CommonService, NotificationService } from '@app/core/Services';
import {
  CommonState,
  CreateVat,
  GetVatDetails,
  SubmitVatState,
  CreateVATReturnStatus,
  SetSubmitVatId,
  MenuState,
  GetVatReturnDate,
} from '@app/core/Store';

import {
  AddClosePopupComponent,
  AddSubmitVatComponent,
  IncludeExcludeTransactionComponent,
  MainListComponent,
  VATDetailsComponent,
} from '@app/modules';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-submit-vat',
  templateUrl: './submit-vat.component.html',
  styleUrls: ['./submit-vat.component.scss'],
})
export class SubmitVatComponent implements OnInit, AfterViewInit {
  isShowSideListAction = false;
  istoggleSideList = false;
  isExpandAll = false;
  isFirstStepDone = false;
  isSecondStepDone = false;
  isThirdStepDone = false;
  capiumButtonShow = false;
  hmrcButtonShow = false;
  isDisable = true;

  moduleId = Modules.SubmitVat;
  moduleName = ModuleName.SubmitVat;
  stepperEnum = Stepper;
  vatReturnStatus = VATReturnStatus;

  submitVatId = Guid.EMPTY as unknown as Guid;
  submitVatData: SubmitVATModel;
  id = Guid.EMPTY as unknown as Guid;

  @Output()
  readonly reloadSideList = new EventEmitter<any>();

  @ViewChild(MatAccordion) accordion: MatAccordion;

  @ViewChild(AddSubmitVatComponent, { static: false })
  submitVatDetails;
  isSubmitHmrc:boolean=false;
  @ViewChild(VATDetailsComponent, { static: false })
  vatDetails;

  @ViewChild(IncludeExcludeTransactionComponent, { static: false })
  includeExcludeTransactionDetails;

  @ViewChild(MainListComponent, { static: false })
  mainListDetails;

  @ViewChild('horizontalStepper') stepper: MatStepper;

  subscriptionRouting: Subscription;

  triggerEditData: Subject<any> = new Subject<any>();
  vatReturnData:any;
  @Select(CommonState.periodicDate)
  periodicDate$: Observable<Array<FinancialData>>;
  isEdit = false;
  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  commonNotificationText = NotificationTextMessage;
  isDeclerationChecked:boolean=false;
  constructor(
    public commonService: CommonService,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private store: Store,
    private spinner: NgxSpinnerService,
    public cookieService: CookieService,
    private router: Router,
    private notifier: NotificationService,
    private _Activatedroute: ActivatedRoute,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.spinner.hide();
    this.subscriptionRouting = this._Activatedroute.paramMap.subscribe(
      (params) => {
        if (params.keys.length > 0) {
          this.isEdit = true;
          this.id = atob(params.get('id')!) as unknown as Guid;
          this.store.dispatch(new SetSubmitVatId(this.id));
          this.editVatDetails();
          if(params.get('isSubmit')){
            this.isSubmitHmrc=true;
            this.isDisable=false;
            this.isDeclerationChecked=true;
            this.spinner.show();
            setTimeout(() => {
              this.redirectTab();
            },100);
          }else{
            this.isSubmitHmrc=false;
            this.isDisable=true;
            this.isDeclerationChecked=false;
          }
        } else {
          this.getVatReturnDate();
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.id =
      this.store.selectSnapshot(SubmitVatState.vatDataId) ??
      (Guid.EMPTY as unknown as Guid);

    if (this.id !== (Guid.EMPTY as unknown as Guid) && !this.isEdit) {
      this.isFirstStepDone = true;
      this.stepper.linear = false;
      this.stepper.selectedIndex = 1;
      setTimeout(() => {
        this.stepper.linear = true;
      });
    }
  }

  showSideListAction(val: boolean): void {
    this.isShowSideListAction = val;
  }

  toggleSideList(val: boolean): void {
    this.istoggleSideList = !this.istoggleSideList;
  }

  toggleAccordion(): void {
    this.isExpandAll = !this.isExpandAll;
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }
  public editVatData:any;
  editVatDetails(): void {
    this.store.dispatch(new GetVatDetails(this.id)).subscribe((res) => {
      this.triggerEditData.next(res.submitVat.vatData);
      this.editVatData=res.submitVat.vatData;
    });
  }

  dataSubmit(): boolean {
    this.spinner.show();
    try {
      this.submitVatData = {
        id: this.id,
        fromDate: this.datepipe
          .transform(
            this.submitVatDetails.submitVatForm.controls.fromDate.value,
            'yyyy-MM-dd'
          )
          ?.toString(),
        toDate: this.datepipe
          .transform(
            this.submitVatDetails.submitVatForm.controls.toDate.value,
            'yyyy-MM-dd'
          )
          ?.toString(),
        description:
          this.submitVatDetails.submitVatForm.controls.description.value,
        finalReturn:
          this.submitVatDetails.submitVatForm.controls.finalReturn.value,
        vatSchemeId:(this.isEdit)?(this.editVatData?.vatSchemeId):this.vatReturnData.vatSchemeId,
      };
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onNextClick(isExit: boolean) {
    if (this.stepper.selectedIndex === 0) {
      if (this.submitVatDetails.submitVatForm.invalid) {
        this.commonService.addValidation(
          this.submitVatDetails.submitVatForm,
          this.renderer
        );
      } else {
        if (this.dataSubmit()) {
          this.store.dispatch(new CreateVat(this.submitVatData)).subscribe(
            (res) => {
              if (res !== undefined) {
                if (!isExit) {
                  this.cancelClick(isExit);
                } else {
                  this.isFirstStepDone = true;
                  this.stepper.linear = false;
                  this.stepper.selectedIndex = 1;
                  setTimeout(() => {
                    this.stepper.linear = true;
                  });
                }
                this.commonService.onSucess(
                  NotificationTextMessage.successMessage
                );
              } else {
                this.commonService.onFailure(
                  NotificationTextMessage.errorMessage
                );
              }
            },
            (err) => {
              this.commonService.onFailure(err.error.Message);
            }
          );
        }
      }
    } else if (this.stepper.selectedIndex === 1) {
      this.isSecondStepDone = true;
      this.capiumButtonShow = true;
      this.stepper.linear = false;
      this.stepper.selectedIndex = 2;
      setTimeout(() => {
        this.stepper.linear = true;
      });
    }
  }

  onSave(vatReturnStatus) {
    this.id = this.store.selectSnapshot(SubmitVatState.vatDataId);
    let obj = {
      id: this.id,
      status: vatReturnStatus,
      fraudHeadersInfo: this.commonService.getFraudHeader(),
    };
    this.store.dispatch(new CreateVATReturnStatus(obj)).subscribe(
      (res) => {
        this.capiumButtonShow = false;
        if (res.submitVat.vatReturnStatusId) {
          if (vatReturnStatus === VATReturnStatus.SubmitToCapium) {
            this.hmrcButtonShow = true;
            this.onCapiuamSuccess();
          } else {
            this.commonService.onSucess(NotificationTextMessage.hmrcSubmitMessage);
            this.router.navigate([RoutingPath.SubmitVAT]);
          }
        } else {
          this.commonService.onFailure(NotificationTextMessage.errorMessage);
        }
      },
      (err) => {
        this.commonService.onFailure(err.error.Message);
      }
    );
  }

  cancelClick(isCancelClick: boolean) {
    if (!isCancelClick) {
      this.router.navigate([RoutingPath.SubmitVAT]);
    }
  }

  onPrevClick(stepper) {
    this.id = this.store.selectSnapshot(SubmitVatState.vatDataId);
    if (this.id) {
      this.editVatDetails();
    }
    this.isSecondStepDone = false;
    stepper.previous();
  }

  onCheckBoxChanges(event: any): void {
    if (event.checked) {
      this.isDisable = false;
    } else {
      this.isDisable = true;
    }
  }

  onCapiuamSuccess(): void {
    this.notifier.success(
      NotificationHeader.success,
      NotificationTextMessage.capiumSaveMessage
    );
  }

  async getVatReturnDate(): Promise<void> {
    await this.store
      .dispatch(new GetVatReturnDate())
      .toPromise()
      .then((res) => {
        this.submitVatDetails.submitVatForm.controls.fromDate.setValue(
          res.submitVat.vatReturnDate.fromDate
        );
        this.submitVatDetails.submitVatForm.controls.toDate.setValue(
          res.submitVat.vatReturnDate.toDate
        );
        this.vatReturnData = res.submitVat.vatReturnDate;
      });
  }
  redirectTab():void{
    this.isSecondStepDone = true;
    this.capiumButtonShow = false;
    this.hmrcButtonShow=true
    this.stepper.linear = false;
    this.stepper.selectedIndex = 2;
      setTimeout(() => {
        this.stepper.linear = true;
        this.spinner.hide();
      });
  
  }
}
